import { PAYMENT_METHOD_TYPES } from '../constants.js'
import { createPaymentMethod } from '../payment-method.js'

export const APP_URL = 'https://fiat.a.exodus.io'

export const PAYMENT_METHOD_NAMES = {
  __proto__: null,
  CARD_PAYMENT: 'CARD_PAYMENT',
  APPLE_PAY: 'APPLE_PAY',
  GOOGLE_PAY: 'GOOGLE_PAY',
}

export const PAYMENT_METHODS = new Map([
  [
    PAYMENT_METHOD_NAMES.APPLE_PAY,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.APPLE_PAY,
      type: PAYMENT_METHOD_TYPES.apple_pay,
      countries: [{ id: 'US', enabled: true }],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.GOOGLE_PAY,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.GOOGLE_PAY,
      type: PAYMENT_METHOD_TYPES.apple_pay,
      countries: [{ id: 'US', enabled: true }],
    }),
  ],
  [
    PAYMENT_METHOD_NAMES.CARD_PAYMENT,
    createPaymentMethod({
      id: PAYMENT_METHOD_NAMES.CARD_PAYMENT,
      type: PAYMENT_METHOD_TYPES.card,
      countries: [{ id: 'US', enabled: true }],
    }),
  ],
])

export const ORDER_STATUSES = {
  __proto__: null,
}

export const EXODUS_ORDER_STATUSES = {
  __proto__: null,
  complete: [],
  failed: [],
  'in-progress': [],
}
